import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

import * as commentsActions from '../../../redux/comments/actions';
import { formatter } from '../../../utils';
import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import styles from './styles.scss';

const ReplyModal = props => {
  const [replyText, setReplyText] = useState('');
  const [replyTextError, setReplyTextError] = useState('');

  useEffect(() => {
    props.actions.clearForm();
  }, []);

  const onSubmit = e => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const standardReplyText = formatter.toStandard(replyText);

    props.actions.reply(props.commentId, standardReplyText).then(() => {
      AlertAndConfirmation({
        title: locales('titles.insertedSuccessfully'),
        text: '',
        type: 'success'
      });
      // props.scrollToComment(props.commentId);
      props.close();
    });
  };

  const onClose = e => {
    e.preventDefault();

    props.close();
  };

  const onChangeReplyText = e => {
    const val = e.target.value;

    if (!val || val.length <= 512) {
      setReplyText(val);
      setReplyTextError('');
    }
  };

  const validateForm = () => {
    let isFormValid = true;

    const standardReplyText = formatter.toStandard(replyText);
    if (!standardReplyText) {
      isFormValid = false;
      const message = locales('messages.fieldValueIsRequired', {
        fieldName: locales('fields.reply.text')
      });
      setReplyTextError(message);
    }

    return isFormValid;
  };

  return (
    <Modal size="lg" isOpen={props.isOpen}>
      <ModalHeader>
        <h4>{locales('titles.commentReply')}</h4>
        <a
          href="#"
          title={locales('labels.close.modal')}
          className={styles.modalClose}
          onClick={onClose}
          disabled={props.loading}
        >
          close
        </a>
      </ModalHeader>
      <ModalBody>
        <Spin spinning={props.loading}>
          <form onSubmit={onSubmit} className="col-12">
            {props.error && (
              <div className="alert alert-danger" role="alert">
                {locales('messages.server.error')}
              </div>
            )}
            {props.failed && (
              <div className="alert alert-danger" role="alert">
                {props.failedMessage}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="replyText" className="form-label">
                {locales('fields.reply.text')}
              </label>
              <textarea
                id="replyText"
                className={`form-control ${styles.replyText} ${
                  !!replyTextError ? 'is-invalid' : ''
                }`}
                value={replyText}
                onChange={onChangeReplyText}
                maxLength="512"
                rows="8"
              />
              <small className="form-text text-muted">
                {locales('messages.reply.text.help.text')}
              </small>
              <div className="invalid-feedback">{replyTextError}</div>
            </div>
          </form>
        </Spin>
      </ModalBody>
      <ModalFooter>
        <button
          type="submit"
          className="btn btn-success"
          onClick={onSubmit}
          disabled={props.loading}
        >
          <i className="fa fa-save"></i>
          {locales('labels.save')}
        </button>
        <button className="btn btn-secondary mx-1" onClick={onClose} disabled={props.loading}>
          <i className="fa fa-times"></i>
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

ReplyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  reply: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToprops = state => ({
  loading: state.commentsReducer.replyToCustomerCommentLoading,
  failed: state.commentsReducer.replyToCustomerCommentFailed,
  error: state.commentsReducer.replyToCustomerCommentError,
  failedMessage: state.commentsReducer.replyToCustomerCommentMessage
});

const mapDispatchToProps = dispatch => ({
  actions: {
    reply: (id, message) => dispatch(commentsActions.replyToCustomerComment(id, message)),
    clearForm: () => dispatch(commentsActions.clearReplyToCustomerComment())
  }
});

export default connect(
  mapStateToprops,
  mapDispatchToProps
)(ReplyModal);
